import React from 'react';
import { Button, Typography, Alert } from 'antd';
import { PlayCircleOutlined } from '@ant-design/icons';
import { useTranslation } from '../../hooks/useTranslation';

const { Text } = Typography;

interface StartCallButtonProps {
  showStartCallButton: boolean;
  isInCall: boolean;
  isConnecting: boolean;
  isTestingAudio: boolean;
  audioDeviceError: string;
  onStartCall: () => void;
  onRunAudioTest: () => void;
  onOpenMicrophoneTest: () => void;
}

const StartCallButton: React.FC<StartCallButtonProps> = ({
  showStartCallButton,
  isInCall,
  isConnecting,
  isTestingAudio,
  audioDeviceError,
  onStartCall,
  onRunAudioTest,
  onOpenMicrophoneTest,
}) => {
  const { t } = useTranslation();

  if (!showStartCallButton || isInCall) {
    return null;
  }

  return (
    <div style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      textAlign: 'center',
      color: 'white'
    }}>
      <Button
        type="primary"
        size="large"
        icon={<PlayCircleOutlined />}
        onClick={onStartCall}
        loading={isConnecting}
        style={{
          height: 80,
          width: 200,
          fontSize: 18,
          borderRadius: 40,
          backgroundColor: '#1890ff',
          border: 'none'
        }}
      >
        {isConnecting ? t('agora.connectingToCall') : t('agora.startCall')}
      </Button>
      <div style={{ marginTop: 16 }}>
        <Text style={{ color: 'white', fontSize: 16 }}>
          {t('agora.clickToStartCall')}
        </Text>
      </div>

      {/* Audio Test Buttons */}
      <div style={{ marginTop: 24, display: 'flex', gap: 8, flexDirection: 'column' }}>
        <Button
          size="small"
          onClick={onRunAudioTest}
          loading={isTestingAudio}
          style={{
            backgroundColor: 'rgba(255,255,255,0.2)',
            color: 'white',
            border: '1px solid rgba(255,255,255,0.3)',
            borderRadius: 20
          }}
        >
          {isTestingAudio ? t('agora.testingAudio') : t('agora.testAudio')}
        </Button>

        <Button
          size="small"
          onClick={onOpenMicrophoneTest}
          style={{
            backgroundColor: 'rgba(59, 130, 246, 0.2)',
            color: 'white',
            border: '1px solid rgba(59, 130, 246, 0.3)',
            borderRadius: 20
          }}
        >
          {t('agora.testMicrophone')}
        </Button>
      </div>

      {/* Audio Status */}
      {audioDeviceError && (
        <div style={{ marginTop: 16, maxWidth: 300 }}>
          <Alert
            message={t('agora.audioIssueDetected')}
            description={audioDeviceError}
            type="warning"
            showIcon
            style={{
              backgroundColor: 'rgba(250, 173, 20, 0.1)',
              border: '1px solid rgba(250, 173, 20, 0.3)'
            }}
          />
        </div>
      )}
    </div>
  );
};

export default StartCallButton;
